(($) => {
  $(document).ready(() => {
    // Open/close the accordion on click.
    $('.paragraph--type--accordion > .accordion-heading').on('click', (evt) => {
      const target = $(evt.currentTarget);
      const accordion = target.parent();
      const content = accordion.find('.accordion-content');
      if (accordion.hasClass('closed')) {
        const height = content.data('content-height');
        content.css('height', `${height}px`);
      } else {
        content.css('height', '0');
      }
      accordion.toggleClass('closed');
    });

    // Save the accordion height to a data attribute.
    $('.paragraph--type--accordion').each((index, element) => {
      const accordion = $(element);
      const accordionContent = accordion.find('.accordion-content');
      const height = accordionContent.height();
      accordionContent.attr('data-content-height', height);
      // Close the accordion.
      accordion.addClass('closed');
      accordionContent.css('height', '0');
    });
  });
})(jQuery);
